/* Gaveta do carrinho (replica da do concorrente). Abre no icone do carrinho e ao adicionar
   produto: intercepta TODO form de /cart/add (inclusive o do buy_buttons nativo, no qual o
   ATC copiado da PDP submete) antes do JS do tema. */
(function () {
  'use strict';
  var D, O, money = '${{amount}}';
  function fmt(c) {
    var n = c / 100, a = n.toFixed(2);
    return money.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/, String(Math.round(n)))
      .replace(/\{\{\s*amount\s*\}\}/, a).replace(/[.,]00(?=\D*$)/, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function bubble(count) {
    // Horizon: <cart-icon> com .cart-bubble (visually-hidden quando vazio) + .cart-bubble__text-count
    document.querySelectorAll('.header-actions__cart-icon, cart-icon').forEach(function (ic) {
      var b = ic.querySelector('.cart-bubble'), n = ic.querySelector('.cart-bubble__text-count');
      if (b) b.classList.toggle('visually-hidden', !count);
      if (n) { n.classList.toggle('hidden', !count); n.textContent = count ? (count < 100 ? count : '') : ''; }
      ic.classList.toggle('header-actions__cart-icon--has-cart', !!count);
    });
  }

  function render(cart) {
    D.classList.toggle('is-empty', !cart.item_count);
    var box = D.querySelector('[data-cl-cart-items]');
    box.innerHTML = cart.items.map(function (it, i) {
      var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title'; })
        .map(function (o) { return '<div class="cl-cart__opt">' + esc(o.name) + ': ' + esc(o.value) + '</div>'; }).join('');
      var price = (it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s>' : '') + fmt(it.final_line_price);
      return '<div class="cl-cart__item" data-line="' + (i + 1) + '">' +
        '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="96" height="96" loading="lazy"></a>' +
        '<div class="cl-cart__info"><div class="cl-cart__top"><a class="cl-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        '<button type="button" class="cl-cart__rm" data-q="0" aria-label="Remove ' + esc(it.product_title) + '">&#10005;</button></div>' + opts +
        '<div class="cl-cart__bottom"><div class="cl-cart__qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span><button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<div class="cl-cart__price">' + price + '</div></div></div></div>';
    }).join('');
    D.querySelector('[data-cl-cart-subtotal]').textContent = fmt(cart.items_subtotal_price);
    D.querySelector('[data-cl-cart-total]').textContent = fmt(cart.total_price);
    // barra de frete gratis (a dele: "You're $X away from free shipping.", cheia acima de 125)
    var FREE = 12500, left = Math.max(0, FREE - cart.items_subtotal_price), sb = D.querySelector('[data-cl-ship]');
    if (sb) {
      sb.style.setProperty('--p', Math.min(100, cart.items_subtotal_price / FREE * 100) + '%');
      sb.innerHTML = left > 0 ? 'You’re <b>' + fmt(left) + '</b> away from free shipping.' : 'You’ve unlocked <b>free shipping</b>!';
    }
    var sr = D.querySelector('[data-cl-ship-row]'); if (sr) sr.textContent = left > 0 ? 'Calculated at checkout' : 'Free';
    bubble(cart.item_count);
    recs(cart);
  }

  var recsFor = null;
  function recs(cart) {
    var wrap = D.querySelector('[data-cl-cart-recs]');
    if (!cart.items.length) { wrap.hidden = true; return; }
    var pid = cart.items[0].product_id;
    if (recsFor === pid) return; recsFor = pid;
    var inCart = cart.items.map(function (x) { return x.product_id; });
    fetch('/recommendations/products.json?product_id=' + pid + '&limit=6&intent=related').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var ps = ((j && j.products) || []).filter(function (p) { return p.available && inCart.indexOf(p.id) < 0; }).slice(0, 4);
      if (!ps.length) { wrap.hidden = true; return; }
      wrap.querySelector('[data-cl-cart-recs-list]').innerHTML = ps.map(function (p) {
        var vs = p.variants.filter(function (v) { return v.available; });
        return '<div class="cl-cart__rec"><a href="/products/' + p.handle + '"><img src="' + esc(img(p.featured_image, 200)) + '" alt="" loading="lazy"></a>' +
          '<div class="cl-cart__rec-info"><a href="/products/' + p.handle + '">' + esc(p.title) + '</a><span>' + fmt(p.price) + '</span>' +
          '<select' + (vs.length > 1 ? '' : ' hidden') + '>' + vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' +
          '<button type="button" data-cl-rec-add>Add to cart</button></div></div>';
      }).join('');
      wrap.hidden = false;
      slide(0);
    }).catch(function () { wrap.hidden = true; });
  }

  // carrossel das recomendacoes (o dele e Flickity: setas, dots, arrasto)
  var ri = 0;
  function slide(i) {
    var sl = D.querySelector('[data-cl-recs-slider]'), list = sl.querySelector('[data-cl-cart-recs-list]');
    var cards = list.children, n = cards.length;
    if (!n) return;
    var view = sl.querySelector('.cl-cart__recs-view').clientWidth;
    var step = cards[0].getBoundingClientRect().width + 10;
    var total = n * step - 10, max = Math.max(0, total - view);
    sl.classList.toggle('is-static', max <= 1);
    n = max <= 1 ? 1 : Math.ceil((max - 1) / step) + 1;   // posicoes distintas
    ri = Math.max(0, Math.min(n - 1, i));
    var x = Math.min(ri * step, max);
    list.style.transform = 'translateX(' + (-x) + 'px)';
    var dots = sl.querySelector('[data-cl-recs-dots]');
    if (dots.children.length !== n) dots.innerHTML = Array.apply(null, Array(n)).map(function (_, k) { return '<li data-cl-recs-dot="' + k + '" aria-label="Page dot ' + (k + 1) + '"></li>'; }).join('');
    Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-selected', k === ri); });
    sl.querySelector('[data-cl-recs-nav="-1"]').disabled = ri === 0;
    sl.querySelector('[data-cl-recs-nav="1"]').disabled = ri >= n - 1;
  }
  function swipe() {
    var sl = D.querySelector('[data-cl-recs-slider]'); if (!sl) return;
    var list = sl.querySelector('[data-cl-cart-recs-list]'), x0 = null, y0 = 0, dx = 0, base = 0, moved = false;
    sl.addEventListener('pointerdown', function (e) {
      if (e.target.closest('select,button')) return;
      x0 = e.clientX; y0 = e.clientY; dx = 0; moved = false;
      var m = /translateX\((-?[\d.]+)px\)/.exec(list.style.transform); base = m ? +m[1] : 0;
    });
    window.addEventListener('pointermove', function (e) {
      if (x0 === null) return;
      dx = e.clientX - x0;
      if (!moved && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(e.clientY - y0)) { moved = true; list.classList.add('is-drag'); }
      if (moved) list.style.transform = 'translateX(' + (base + dx) + 'px)';
    });
    window.addEventListener('pointerup', function () {
      if (x0 === null) return;
      x0 = null; list.classList.remove('is-drag');
      if (moved) slide(ri + (dx < -40 ? 1 : dx > 40 ? -1 : 0));
    });
    sl.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    window.addEventListener('resize', function () { if (!D.querySelector('[data-cl-cart-recs]').hidden) slide(ri); });
  }

  function get() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refresh() { D.classList.add('is-loading'); return get().then(function (c) { render(c); D.classList.remove('is-loading'); return c; }); }
  function open() {
    refresh();
    document.documentElement.classList.add('cl-cart-open'); document.body.classList.add('cl-cart-lock');
    D.setAttribute('aria-hidden', 'false'); setTimeout(function () { D.focus(); }, 50);
  }
  function close() {
    document.documentElement.classList.remove('cl-cart-open'); document.body.classList.remove('cl-cart-lock');
    D.setAttribute('aria-hidden', 'true');
  }
  function change(line, q) {
    D.classList.add('is-loading');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: Math.max(0, q) }) })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); D.classList.remove('is-loading'); });
  }
  function add(body) {
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function boot() {
    D = document.getElementById('ClCartDrawer'); O = document.getElementById('ClCartOverlay');
    if (!D) return;
    money = D.getAttribute('data-money') || money;
    swipe();
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cl-cart-close]')) { e.preventDefault(); close(); return; }
      var icon = t.closest('#cart-icon-bubble, a[href="/cart"], a[href^="/cart?"], .action__cart');
      if (icon && !icon.closest('#ClCartDrawer')) { e.preventDefault(); e.stopImmediatePropagation(); open(); return; }
      var q = t.closest('#ClCartDrawer [data-q]');
      if (q) { var line = +q.closest('[data-line]').getAttribute('data-line'); change(line, +q.getAttribute('data-q')); return; }
      var nv = t.closest('[data-cl-recs-nav]');
      if (nv) { e.preventDefault(); slide(ri + +nv.getAttribute('data-cl-recs-nav')); return; }
      var dt = t.closest('[data-cl-recs-dot]');
      if (dt) { slide(+dt.getAttribute('data-cl-recs-dot')); return; }
      var ra = t.closest('[data-cl-rec-add]');
      if (ra) {
        var sel = ra.parentElement.querySelector('select'); ra.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +sel.value, quantity: 1 }] }) })
          .then(function () { ra.disabled = false; recsFor = null; refresh(); }).catch(function () { ra.disabled = false; });
      }
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.documentElement.classList.contains('cl-cart-open')) close(); });
    // todo form de /cart/add (ATC da PDP, quick add, upsell) -> ajax + abre a gaveta
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (f.__clValidate && !f.__clValidate()) return;   // buybox: tamanho nao escolhido
      var fd = new FormData(f, e.submitter || undefined);
      var btns = document.querySelectorAll('[form="' + f.id + '"][type=submit], #' + (f.id ? CSS.escape(f.id) : 'x') + ' [type=submit]');
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      add(fd).then(function () { open(); }).catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart';
        var box = document.querySelector('.cl-pdp .product-form__error-message-wrapper, .cl-pdp .clx-product-form__error-message-wrapper');
        if (box) { box.hidden = false; var sp = box.querySelector('.product-form__error-message'); if (sp) sp.textContent = msg; } else { alert(msg); }
      }).then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    }, true);
    document.addEventListener('cl:cart:open', open);
    get().then(function (c) { bubble(c.item_count); }).catch(function () {});
    window.clCart = { open: open, close: close, refresh: refresh };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
